// import React from 'react';
// import ClientProcessMap from '../components/ClientProcessMap';
import { Card, Container } from 'react-bootstrap';

const JustizLanding = () => {
  return (
    <Container className="mt-4 flex">
      {/* <h2>Client Dashboard</h2> */}
      {/* <ClientProcessMap /> */}
      {/* <Container className="card-group"> */}
        <a href="/standards" style={{ textDecoration: 'none', color: 'inherit' }}>
          <Card className="mb-4">
            <Card.Body>
              <Card.Title>Standards</Card.Title>
              <Card.Text>
                {/* This is your central hub for managing legal processes and documentation. */}
              </Card.Text>
            </Card.Body>
          </Card>
        </a>
        <a href="/medizinprodukteregister" style={{ textDecoration: 'none', color: 'inherit' }}>
          <Card className="mb-4">
            <Card.Body>
              <Card.Title>Medizinprodukteregister</Card.Title>
              <Card.Text>
                {/* You have 3 new case updates and 2 pending approvals. */}
              </Card.Text>
            </Card.Body>
          </Card>
        </a>
        <a href="/documents" style={{ textDecoration: 'none', color: 'inherit' }}>
          <Card className="mb-4">
            <Card.Body>
              <Card.Title>Vorschriften</Card.Title>
              <Card.Text>
                {/* Access your cases, documents, and settings quickly from here. */}
              </Card.Text>
            </Card.Body>
          </Card>
        </a>
        <a href="/massnahmen" style={{ textDecoration: 'none', color: 'inherit' }}>
          <Card className="mb-4">
            <Card.Body>
              <Card.Title>Maßnahmen</Card.Title>
              <Card.Text>
                {/* Review and update your personal and account settings. */}
              </Card.Text>
            </Card.Body>
          </Card>
        </a>
      </Container>
    // </Container>
  );
};

export default JustizLanding;
